import { render, staticRenderFns } from "./RealTimeF2FMain.vue?vue&type=template&id=4ac1220e"
import script from "./RealTimeF2FMain.vue?vue&type=script&lang=js"
export * from "./RealTimeF2FMain.vue?vue&type=script&lang=js"
import style0 from "./RealTimeF2FMain.vue?vue&type=style&index=0&id=4ac1220e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports